import { logoMap } from "@biggeo/bg-utils";
import {
    CloudStorageType,
    PurchasedDataSourceConnectionWithOrganization,
} from "@biggeo/bg-server-lib/studio";
import {
    Button,
    CellItem,
    CompanyAvatar,
    FlexScrollArea,
    FlexScrollAreaContainer,
    Grid,
    Stack,
    ThumbnailAvatar,
    Typography,
} from "@biggeo/bg-ui/lab";
import { CompareArrowsOutline } from "@biggeo/bg-ui/lab/icons";
import React from "react";
import { Link } from "react-router-dom";
import { Routes } from "../../navigation/redux/model";

interface ISuccessfulAccessKey {
    readonly response: PurchasedDataSourceConnectionWithOrganization;
    readonly onClickDone: () => void;
}

const SuccessfulAccessKey = ({
    response,
    onClickDone,
}: ISuccessfulAccessKey) => {
    return (
        <FlexScrollAreaContainer height="100%">
            <Stack gap={2} alignSelf="center">
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                >
                    <ThumbnailAvatar src={undefined} square size="md" />
                    <CompareArrowsOutline size="xs" color="disabled" />
                    <ThumbnailAvatar
                        src={
                            "https://sabiggeomedia01.blob.core.windows.net/media/bg-background.png"
                        }
                        square
                        size="md"
                    />
                </Grid>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    align="center"
                    textTransform="capitalize"
                >
                    Dataset
                    {response.purchasedDatasetConnection.length > 1 ? "s" : ""}{" "}
                    unlocked!
                </Typography>
                <Grid item sx={{ textAlign: "center" }}>
                    <Link
                        to={`${Routes.bigGeoProductsDatalab}`}
                        target="_blank"
                    >
                        <Typography
                            variant="body3"
                            color="primary"
                            sx={{
                                display: "inline",
                            }}
                        >
                            {response.organization.name}{" "}
                        </Typography>
                    </Link>
                    <Typography
                        variant="body3"
                        sx={{
                            display: "inline",
                        }}
                    >
                        has given you access to these datasets
                    </Typography>
                </Grid>
            </Stack>
            <FlexScrollArea
                sx={{
                    flexDirection: "column",
                    padding: 4,
                    minHeight: (theme) => theme.spacing(26),
                }}
            >
                <Stack height="100%" width="100%" gap={2} alignSelf="center">
                    {response.purchasedDatasetConnection.map(
                        (purchasedDataset) => {
                            const dataSource =
                                purchasedDataset.dataset.dataSource;

                            const location =
                                purchasedDataset.dataset.etlDatasetLocation;
                            const img = location
                                ? location.cloudStorageInfo.cloudStorageType ===
                                  CloudStorageType.Upload
                                    ? logoMap[CloudStorageType.Azure]
                                    : logoMap[
                                          location.cloudStorageInfo
                                              .cloudStorageType
                                      ]
                                : undefined;

                            return (
                                <CellItem
                                    density="dense"
                                    startNode={
                                        <CompanyAvatar
                                            color={"primary"}
                                            size="sm"
                                            src={img || ""}
                                            alt={dataSource.name}
                                        />
                                    }
                                    variant="outlined"
                                    key={dataSource.id}
                                    title={dataSource.name}
                                    readonly
                                />
                            );
                        }
                    )}
                </Stack>
            </FlexScrollArea>
            <Stack
                sx={{
                    padding: 4,
                }}
            >
                <Button fullWidth onClick={onClickDone}>
                    Done
                </Button>
            </Stack>
        </FlexScrollAreaContainer>
    );
};
export default SuccessfulAccessKey;
